import { isQA } from "@src/constants/constants";
import mixpanel, { Dict } from "mixpanel-browser";

const disableMixpanel = isQA;
const mixPanelToken = process.env.MIXPANEL_TOKEN;

export enum MixpanelCategory {
	// Filters section
	COMPANY_NAME_FILTER = "Filter: Company Name Filter",
	SMART_SEARCH_FILTER = "Filter: Smart Search Filter",
	EVENT_NAME_FILTER = "Filter: Event Name Filter",
	HEADLINER_FILTER = "Filter: Headliner Filter",
	VENUE_FILTER = "Filter: Venue Filter",
	START_DATE_FILTER = "Filter: Start Date Filter",
	END_DATE_FILTER = "Filter: End Date Filter",
	ADDITIONAL_FILTERS_BUTTON = "Filter: Additional Filters Button",
	SAVED_FILTERS = "Filter: Saved Filters",
	TAGS_FILTER = "Filter: Tags Filter",
	TICKET_SECTION = "Filter: Ticket Section",
	TICKET_ROW = "Filter: Ticket Row",
	TICKET_MIN_QUANTITY = "Filter: Ticket Min.Quantity",
	TICKET_DAYS_SINCE_LAST_UPDATE = "Filter: Ticket Days Since Last Update",
	ADVANCED_LISTING_ID = "Filter: Advanced - Listing ID",
	ADVANCED_EVENT_ID = "Filter: Advanced - Event ID",
	ADVANCED_PO_ID = "Filter: Advanced - PO ID",
	ADVANCED_PO_START_DATE = "Filter: Advanced - PO Start Date",
	ADVANCED_PO_END_DATE = "Filter: Advanced - PO End Date",
	SHOW_PARKING = "Filter: Show Parking",
	SHOW_CANCELED = "Filter: Show Canceled",
	SAVE_FILTERS = "Filter: Save Filters",

	// Events section
	NEXT_7_DAYS = "Events: Next 7 Days",
	SHOW_SOLD_EVENTS = "Events: Show Sold",
	NEW_LAYOUT = "Events: New Layout",
	CUSTOMIZE_EVENTS = "Events: Customize",
	SAVE_PRESET_CUSTOMIZE = "Events: Save Preset from Customize",
	SAVE_PRESET_SELECTION = "Events: Save Preset Selection",
	RESIZE = "Events: Resize",
	CONTEXT_MENU_ADD_TAGS = "Events: Context Menu for Add Tags",

	// Map section
	SELECT_MAP_BUTTON = "Map: Select Map Button",
	MAP_INTERACTION = "Map: Map Interaction",

	// Inventory section
	FETCH = "Inventory: Fetch",
	SHOW_SOLD_INVENTORY = "Inventory: Show Sold",
	SHOW_ON_HOLD_INVENTORY = "Inventory: Show On Hold",
	AUTOPRICER_INVENTORY = "Inventory: AutoPricer",
	CUSTOMIZE_INVENTORY = "Inventory: Customize",
	LISTING_CHECKBOX = "Inventory: Listing Checkbox",
	BULK_ACTIONS = "Inventory: Bulk Actions",
	EDIT_INVENTORY = "Inventory: Edit",
	CONTEXT_MENU_INVENTORY = "Inventory: Context Menu",
	PRICE_UPDATE = "Inventory: Price Update",

	// Context menu
	AUTOPRICER_MENU = "Context Menu: Autopricer",
	LISTING_INFO = "Context Menu: Listing Info",
	SHARE_UNSHARE = "Context Menu: Share/Unshare",
	TICKETS = "Context Menu: Tickets",
	INTERNAL_NOTES = "Context Menu: Internal Notes",
	EXTERNAL_NOTES = "Context Menu: External Notes",
	ATTACH_PDFS = "Context Menu: Attach PDFs",
	SCHEDULE_PRICER = "Context Menu: Schedule Pricer",
	FLASH_SALE = "Context Menu: Flash Sale",
	PURCHASE_INFORMATION = "Context Menu: Purchase Information",
	ADD_TAG = "Context Menu: Add Tag",
	SPLIT_LISTINGS = "Context Menu: Split Listings",
	RELIST = "Context Menu: Relist",
	ADD_E_DELIVERY = "Context Menu: Add E-Delivery",
	REMOVE_E_DELIVERY = "Context Menu: Remove E-Delivery",
	DUPLICATE_LISTING = "Context Menu: Duplicate Listing",
	VIEW_HISTORY = "Context Menu: View History",
	HELP_SUPPORT = "Context Menu: Help & Support",

	// Edit section
	APPLY_LISTING_INFO = "Edit: Apply Listing Info",
	SAVE_TICKETS_UPDATES = "Edit: Save Tickets Updates",
	APPLY_SHARING_RULE = "Edit: Apply Sharing Rule",
	ADD_EDIT_INTERNAL_NOTES = "Edit: Add/Edit Internal Notes",
	ADD_EDIT_EXTERNAL_NOTES = "Edit: Add/Edit External Notes",
	ADD_EDIT_ATTACH_PDFS = "Edit: Add/Edit Attach PDFs",
	PRICE_LOG = "Edit: Price Log",
	SCHEDULE_PRICING = "Edit: Schedule Pricing",
	SET_FLASH_SALE = "Edit: Set Flash Sale",
	ADD_EDIT_PURCHASE_INFORMATION = "Edit: Add/Edit Purchase Information",
	ADD_EDIT_TAGS = "Edit: Add/Edit Tags",
	SPLIT_LISTING = "Edit: Split Listing",

	// Feed section
	ACTIVE_LISTINGS = "Feed: Active Listings",
	SOLD_LISTINGS = "Feed: Sold Listings",
	SHOW_CHARTS = "Feed: Show Charts",
	RE_FETCH_ALL = "Feed: Re-Fetch All",

	// Autopricer
	CEILING_PRICE = "AutoPricer: Ceiling Price (menu)",
	FLOOR_PRICE = "AutoPricer: Floor Price (menu)",
	OPEN_AUTOPRICER = "AutoPricer: Open Autopricer",
	REMOVE_AUTOPRICER = "AutoPricer: Remove Autopricer",
	LOWEST_COMPARABLE = "AutoPricer: Lowest Comparable (menu)",

	// Additional Metrics
	EDIT_LISTING_RETENTION = "Portal Edit Listing Retention Duration",
}

if (mixPanelToken) {
	mixpanel.init(mixPanelToken, {
		debug: false,
		track_pageview: true,
		persistence: "localStorage",
	});
} else {
	console.log(
		"%cMixpanel token missing, tracking not available",
		"background-color:#4f44e0;border-radius:8px;padding: 2px 10px",
	);
}

export const mixpanelTrack = (event: MixpanelCategory, eventData?: Dict) => {
	if (!mixPanelToken || !event || disableMixpanel) return;
	mixpanel.track(event, {
		data: eventData,
	});
};
